import { render, staticRenderFns } from "./VModalError.vue?vue&type=template&id=cfd204da&"
import script from "./VModalError.vue?vue&type=script&lang=ts&"
export * from "./VModalError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports